function Comp17() {
    $(".comp-17").each(function () {
        const comp = $(this);
        const btns = comp.find(".comp-17-tabBtn .btn");
        const contents = comp.find(".comp-17-tabPane");

        // Aktif buton varsa onu seç, yoksa ilkini al
        const activeBtn = btns.filter(".active").length
            ? btns.filter(".active")
            : btns.first();
        const target = activeBtn.attr("href");

        btns.removeClass("active");
        contents.removeClass("active").hide();

        // Aktif buton ve içerik ayarla
        activeBtn.addClass("active");
        comp.find(target).addClass("active").show();

        // Tıklama olayları
        btns.on("click", function (e) {
            e.preventDefault();
            const target = $(this).attr("href");

            btns.removeClass("active");
            contents.removeClass("active").hide();

            $(this).addClass("active");
            comp.find(target).addClass("active").fadeIn(200);
        });
    });
}

Comp17();
